
import {RecordEN} from "./record/en";
import {OkrEN} from "./okr/en";

export const PersonnelEN = {
    "hrm": "HRM",
    "personnel": "Personnel",
    "application": "Application",
    ...OkrEN,
    ...RecordEN,
}